
















































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// types
import { Settings } from "@/services/stages/types";
// validation
import validate from "@/directives/validate";
import { settingsValidators } from "@/components/stages/validators";

@Component({
    directives: {
        validate
    }
})
export default class StageSettings extends Vue {
    @Prop() settings!: Settings;
    @Prop() collapseState!: boolean;

    // local state
    localCollapseState = true;
    localSettings = {
        contentTimeout: 15
    } as Settings;

    validators = settingsValidators;
    // Watchers
    @Watch("settings")
    onPropertyChanged(value: boolean, oldValue: any) {
        this.localSettings = this.settings;
    }

    // lifecycle hooks
    mounted() {
        this.localCollapseState = this.collapseState;
    }
    // computed

    // methods

    emitData() {
        this.$emit("settingsUpdated", this.localSettings);
    }

    setState(state: boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "StageSettings", state: state });
    }
}
